import React, {Component} from 'react';
import {Button, ControlLabel, FormGroup, Modal, Radio} from 'react-bootstrap';
import axios from 'axios';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import ErrorMessageContainer from './ErrorMessageContainer';

require('moment/locale/el');

export default class ContractDeliverableDeliveredModal extends Component {
    constructor() {
        super();

        this.state = {
            deliverable_id: 0,
            delivered_at: moment(),
            delivered: 0,
            submit_disabled: false,
            validationErrors: []
        };

        this.getData = this.getData.bind(this);
        this.close = this.close.bind(this);
        this.submit = this.submit.bind(this);
        this.radioChange = this.radioChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            deliverable_id: nextProps.id
        }, () => {
            this.getData();
        });
    }

    getData() {
        if (this.state.deliverable_id !== 0) {
            let url = "/contracts/ajax/manage_contracts/" + this.props.contractId + "/deliverables_delivered/" + this.state.deliverable_id;
            axios
                .get(url)
                .then((response) => {
                    let delivered_at = response.data;

                    if (delivered_at === null)
                        delivered_at = moment();
                    else if (delivered_at === "")
                        delivered_at = "";
                    else
                        delivered_at = moment(delivered_at, "DD/MM/YYYY");

                    this.setState({
                        delivered: (response.data !== null ? 1 : 0),
                        delivered_at: delivered_at
                    });
                });
        }
    }

    close() {
        this.props.closeCallback();
    }

    submit() {
        if (!this.state.submit_disabled) {
            this.setState({
                validationErrors: [],
                submit_disabled: true
            }, () => {
                let url = "/contracts/ajax/manage_contracts/" + this.props.contractId + "/deliverables_delivered/" + this.state.deliverable_id;

                let delivered_at = null;
                if (this.state.delivered === 1) {
                    if (this.state.delivered_at === "" || this.state.delivered_at === null)
                        delivered_at = "";
                    else
                        delivered_at = this.state.delivered_at.format("DD/MM/YYYY");
                }

                axios
                    .post(url, {
                        delivered: this.state.delivered,
                        delivered_at: delivered_at
                    })
                    .then((response) => {
                        this.setState({submit_disabled: false}, () => {
                            this.close();
                        });
                    })
                    .catch((failure) => {
                        this.setState({
                            validationErrors: failure.response.data,
                            submit_disabled: false
                        });
                    });
            });
        }
    }

    radioChange(value) {
        this.setState({delivered: value});
    }

    handleDateChange(date) {
        this.setState({delivered_at: date});
    }

    render() {
        return (
            <Modal show={this.props.showModal}
                   onHide={this.close}>
                <Modal.Header closeButton>
                    <Modal.Title> {window.__js_contracts.delivery_tracking}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorMessageContainer errors={this.state.validationErrors}/>

                    <FormGroup>
                        <Radio name="delivered"
                               value="0"
                               checked={this.state.delivered === 0}
                               onChange={() => this.radioChange(0)}>
                            <span
                                dangerouslySetInnerHTML={{__html: window.__js_contracts.deliverable_not_received}}></span>
                        </Radio>
                        <Radio name="delivered"
                               value="1"
                               checked={this.state.delivered === 1}
                               onChange={() => this.radioChange(1)}>
                            <span dangerouslySetInnerHTML={{__html: window.__js_contracts.deliverable_received}}></span>
                        </Radio>
                    </FormGroup>
                    <FormGroup controlId="delivered_at"
                               className={this.state.delivered === 1 ? "" : "hidden"}
                               style={{paddingLeft: "20px"}}>
                        <ControlLabel>{window.__js_contracts.received_date}*</ControlLabel>
                        <DatePicker className="form-control"
                                    name="delivered_at"
                                    id="delivered_at"
                                    selected={this.state.delivered_at}
                                    onChange={this.handleDateChange}
                                    dateFormat="DD/MM/YYYY"
                                    locale="el"/>
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.close}>{window.__js_general.close}</Button>
                    <Button onClick={this.submit}
                            bsStyle="primary"
                            disabled={this.state.submit_disabled}>
                        {window.__js_general.save}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}